/**
 * Desktop content column: `max-w-page` (1200px) in tailwind.config.js.
 * Gutters: tight on small screens; from `lg` no horizontal inset inside the 1200px shell
 * so copy and forms use the full band (Figma 1200 content width).
 */
export const PAGE_MAX = "max-w-page mx-auto w-full";
export const PAGE_GUTTER_X = "px-3 sm:px-4 md:px-6 lg:px-0";
